(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('TimeSeriesData', TimeSeriesData);

    TimeSeriesData.$inject = ['$resource', 'DateUtils'];

    function TimeSeriesData ($resource, DateUtils) {
        var resourceUrl =  'api/timeseries-data';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
